if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          // CART ERROR EVENT
          if (response.status) {
            document.dispatchEvent(
              new CustomEvent("cart:error", {
                detail: {
                  source: this.dataset.source,
                  productVariantId: formData.get("id"),
                  errors: response.description,
                  message: response.message
                }
              })
            );
            // -------------------------------------------
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // VARIANT ADDED EVENT
          document.dispatchEvent(
            new CustomEvent("variant:add", {
              detail: {
                variant: {
                  id: formData.get("id")
                },
                quantity: Number(formData.get("quantity") || 1),
                formElement: this.form,
                sectionId: this.dataset.source
              }
            })
          );
          // -------------------------------------------

          fetch(`${routes.cart_url}.js`)
            .then((response) => {
              return response.text()
            })
            .then((state) => {
              const parsedState = JSON.parse(state)

              // dispatch cart:change for the entire basket
              document.dispatchEvent(
                new CustomEvent('cart:change', {
                  detail: {
                    cart: parsedState,
                    sectionId: this.dataset.source,
                  },
                })
              )

// UPDATE CART COUNT
    const cartBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');

    if (cartBubble) {
      const count = parsedState.item_count;

      const visibleCount = cartBubble.querySelector('span[aria-hidden="true"]');
      const hiddenCount = cartBubble.querySelector('.visually-hidden');

      if (visibleCount) {
        visibleCount.textContent = count;
      }

      if (hiddenCount) {
        hiddenCount.textContent = `${count} item${count !== 1 ? 's' : ''}`;
      }
    }
    // END CART COUNT UPDATE

              // dispatch cart:change for the entire basket

            })
            .catch((error) => {
              console.error('Error fetching cart state:', error);
            })

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;

          animateAddToCart(this.submitButton);
    
const noCartOpen = this.submitButton.hasAttribute('data-no-cart-open');

if (noCartOpen) {
  this.cart.refreshCart();
} else {
  const quickAddModal = this.closest('quick-add-modal');

  if (quickAddModal) {
    document.body.addEventListener('modalClosed', () => {
      setTimeout(() => {
        this.cart.renderContents(response);
      });
    }, { once: true });

    quickAddModal.hide(true);
  } else {
    this.cart.renderContents(response);
  }
}        
        
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


// ========================================
// PRODUCT IMAGE FLY TO CART ANIMATION
// ========================================

function animateAddToCart(button) {
  const cartIcon = document.querySelector('#cart-icon-bubble');

  if (!button || !cartIcon) {
    console.log('Cart animation: button or cart icon not found');
    return;
  }

  const buttonIcon = button.querySelector('img');

  if (!buttonIcon) {
    console.log('Cart animation: button image not found');
    return;
  }

  const start = buttonIcon.getBoundingClientRect();
  const end = cartIcon.getBoundingClientRect();

  const flyingIcon = buttonIcon.cloneNode(true);

  flyingIcon.style.position = 'fixed';
  flyingIcon.style.left = `${start.left}px`;
  flyingIcon.style.top = `${start.top}px`;
  flyingIcon.style.width = `${start.width}px`;
  flyingIcon.style.height = `${start.height}px`;
  flyingIcon.style.margin = '0';
  flyingIcon.style.zIndex = '999999';
  flyingIcon.style.pointerEvents = 'none';
  flyingIcon.style.transition =
    'left 1s cubic-bezier(0.4, 0, 0.2, 1), ' +
    'top 1s cubic-bezier(0.4, 0, 0.2, 1), ' +
    'width 1s ease, height 1s ease, opacity 1s ease';

  document.body.appendChild(flyingIcon);

  // Force browser to register starting position
  flyingIcon.getBoundingClientRect();

  requestAnimationFrame(() => {
    flyingIcon.style.left =
      `${end.left + (end.width / 2) - (start.width / 4)}px`;

    flyingIcon.style.top =
      `${end.top + (end.height / 2) - (start.height / 4)}px`;

    flyingIcon.style.width = `${start.width * 0.35}px`;
    flyingIcon.style.height = `${start.height * 0.35}px`;
    flyingIcon.style.opacity = '0';
  });

  setTimeout(() => {
    flyingIcon.remove();
  }, 700);
}